export const BUSINESS_NAME = "Tortásticas";
export const API_URL = "https://tas.administrat.net/clienteappserver/";
export const LOGO_URL = "https://tas.administrat.net/logo_tas.png";
export const BASE_URL = "https://tas.administrat.net/";
